var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLogoOffice365 = function SvgLogoOffice365(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.688 3.326v9.473L2.667 11.76l6.975 2.906 3.691-1.306V2.394l-3.65-1.06-7.016 2.608v7.72l2.311-.87.008-6.35 4.702-1.116Z",
    fill: "#DA3726"
  })));
};
export { SvgLogoOffice365 as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTkuNjg4MjMgMy4zMjU5MVYxMi43OTg3TDIuNjY2NzUgMTEuNzYxNEw5LjY0MiAxNC42NjY2TDEzLjMzMzQgMTMuMzYxNFYyLjM5MzhMOS42ODMzNiAxLjMzMzI1TDIuNjY2NzUgMy45NDI0M1YxMS42NjIzTDQuOTc4NDUgMTAuNzkyNkw0Ljk4NTc1IDQuNDQxNTFMOS42ODgyMyAzLjMyNTkxWiIgZmlsbD0iI0RBMzcyNiIvPgo8L3N2Zz4K";